import {Document, Page} from "react-pdf"
import "react-pdf/dist/Page/TextLayer.css"
import "react-pdf/dist/Page/AnnotationLayer.css"
import {ModalPdfNav} from "../Modals/ModalPdfNav"
import {ImageTransformControls} from "../ImageTransformControls/ImageTransformControls"
import {useToolbar} from "../../hooks/useToolbar"
import {ApplicationDocumentSide} from "../../resources/application"
import ScrollContainer from "react-indiana-drag-scroll"
import React, {useState} from "react"

// Configure PDF.js worker and options (WASM for JPEG 2000 / OpenJPEG)
import "../../pdfWorker"
import {pdfDocumentOptions} from "../../pdfOptions"

interface Props {
	pdfUrl: string
}

export function PdfDocumentViewer({pdfUrl}: Props) {
	const [pageNumber, setPageNumber] = useState(1)
	const [numPages, setNumPages] = useState(1)
	const handlePdfSuccess = ({numPages}: {numPages: number}) => setNumPages(numPages)
	const {zoom, rotation} = useToolbar(ApplicationDocumentSide.Front)

	return (
		<div className="pdf-document-viewer">
			<div className="pdf-document-viewer-controls">
				<div className="pdf-document-viewer-page-navigation">
					{numPages > 1 && <ModalPdfNav pageNumber={pageNumber} numPages={numPages} setPageNumber={setPageNumber} />}
				</div>
				<div className="pdf-document-viewer-zoom-controls">
					<ImageTransformControls
						changeRotation={rotation.changeRotation}
						zoomIn={zoom.zoomIn}
						zoomOut={zoom.zoomOut}
						zoomVal={zoom.val}
					/>
				</div>
			</div>
			<ScrollContainer
				className="pdf-document-viewer-scroll-container"
				vertical={true}
				horizontal={true}
				hideScrollbars={false}
			>
				<Document options={pdfDocumentOptions} file={pdfUrl} onLoadSuccess={handlePdfSuccess} className="pdf-document">
					<Page pageNumber={pageNumber} scale={zoom.val} rotate={rotation.val} />
				</Document>
			</ScrollContainer>
		</div>
	)
}
